module.exports = __webpack_public_path__ + "static/headerBg.c73eee3f.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/FaqPage/headerBg.svg
// module id = 789
// module chunks = 0